<template>
    <div class="h-full w-full flex flex-col bg-white shadow-lg">
        <div class="h-56 bg-indigo-300 animate-pulse"></div>
        <div class="flex-auto p-4 flex flex-col">
            <h1 class="bg-primaryLight h-8 animate-pulse"></h1>
            <div class="flex-auto flex flex-col justify-end mt-4">
                <p class="text-sm bg-slate-500 h-4 w-1/3 animate-pulse"></p>
            </div>
        </div>
    </div>
</template>